
import { WorldCity } from '../types';

// Expansión de Chile - 75 ciudades adicionales
export const chileAdditionalCities: WorldCity[] = [
  { name: 'Valparaíso', slug: 'valparaiso', population: 296655 },
  { name: 'Concepción', slug: 'concepcion', population: 223574 },
  { name: 'La Serena', slug: 'la-serena', population: 221054 },
  { name: 'Antofagasta', slug: 'antofagasta', population: 361873 },
  { name: 'Temuco', slug: 'temuco', population: 282415 },
  { name: 'Rancagua', slug: 'rancagua', population: 236363 },
  { name: 'Talca', slug: 'talca', population: 197479 },
  { name: 'Arica', slug: 'arica', population: 176601 },
  { name: 'Chillán', slug: 'chillan', population: 165528 },
  { name: 'Iquique', slug: 'iquique', population: 180601 },
  { name: 'Los Ángeles', slug: 'los-angeles-chile', population: 166556 },
  { name: 'Coquimbo', slug: 'coquimbo', population: 161317 },
  { name: 'Osorno', slug: 'osorno', population: 145475 },
  { name: 'Valdivia', slug: 'valdivia', population: 140559 },
  { name: 'Quilpué', slug: 'quilpue', population: 128578 },
  { name: 'Curicó', slug: 'curico', population: 119037 },
  { name: 'Calama', slug: 'calama', population: 143084 },
  { name: 'Puerto Montt', slug: 'puerto-montt', population: 245902 },
  { name: 'Copiapó', slug: 'copiapo', population: 129280 },
  { name: 'Villa Alemana', slug: 'villa-alemana', population: 126548 },
  { name: 'San Bernardo', slug: 'san-bernardo', population: 301313 },
  { name: 'Melipilla', slug: 'melipilla', population: 129096 },
  { name: 'Ovalle', slug: 'ovalle', population: 98089 },
  { name: 'Linares', slug: 'linares', population: 83249 },
  { name: 'Talagante', slug: 'talagante', population: 63978 },
  { name: 'Graneros', slug: 'graneros', population: 29572 },
  { name: 'Rengo', slug: 'rengo', population: 54888 },
  { name: 'San Fernando', slug: 'san-fernando', population: 66921 },
  { name: 'Cauquenes', slug: 'cauquenes', population: 41217 },
  { name: 'Parral', slug: 'parral', population: 41242 },
  { name: 'San Carlos', slug: 'san-carlos', population: 50088 },
  { name: 'Angol', slug: 'angol', population: 48996 },
  { name: 'Villarrica', slug: 'villarrica', population: 59103 },
  { name: 'Lautaro', slug: 'lautaro', population: 40746 },
  { name: 'Nueva Imperial', slug: 'nueva-imperial', population: 33777 },
  { name: 'Traiguén', slug: 'traiguen', population: 19314 },
  { name: 'Pitrufquén', slug: 'pitrufquen', population: 26096 },
  { name: 'Loncoche', slug: 'loncoche', population: 24739 },
  { name: 'Gorbea', slug: 'gorbea', population: 15222 },
  { name: 'Freire', slug: 'freire', population: 25367 },
  { name: 'Carahue', slug: 'carahue', population: 25486 },
  { name: 'Castro', slug: 'castro', population: 43807 },
  { name: 'Ancud', slug: 'ancud', population: 39946 },
  { name: 'Quellón', slug: 'quellon', population: 25117 },
  { name: 'Coyhaique', slug: 'coyhaique', population: 57818 },
  { name: 'Puerto Aysén', slug: 'puerto-aysen', population: 24424 },
  { name: 'Punta Arenas', slug: 'punta-arenas', population: 127454 },
  { name: 'Puerto Natales', slug: 'puerto-natales', population: 22116 },
  { name: 'Porvenir', slug: 'porvenir', population: 6612 },
  { name: 'San Antonio', slug: 'san-antonio', population: 91350 },
  { name: 'Quillota', slug: 'quillota', population: 75916 },
  { name: 'Limache', slug: 'limache', population: 42240 },
  { name: 'La Ligua', slug: 'la-ligua', population: 34490 },
  { name: 'Petorca', slug: 'petorca', population: 9440 },
  { name: 'Cabildo', slug: 'cabildo', population: 19975 },
  { name: 'Casablanca', slug: 'casablanca', population: 25943 },
  { name: 'Isla de Pascua', slug: 'isla-de-pascua', population: 5761 },
  { name: 'Juan Fernández', slug: 'juan-fernandez', population: 633 },
  { name: 'Maipú', slug: 'maipu', population: 578605 },
  { name: 'Las Condes', slug: 'las-condes', population: 294838 },
  { name: 'Puente Alto', slug: 'puente-alto', population: 645909 },
  { name: 'Peñalolén', slug: 'penalolen', population: 266798 },
  { name: 'La Florida', slug: 'la-florida', population: 402433 },
  { name: 'Providencia', slug: 'providencia', population: 142079 },
  { name: 'Ñuñoa', slug: 'nunoa', population: 227446 },
  { name: 'Vitacura', slug: 'vitacura', population: 96774 },
  { name: 'Lo Barnechea', slug: 'lo-barnechea', population: 124076 },
  { name: 'Macul', slug: 'macul', population: 134635 },
  { name: 'San Miguel', slug: 'san-miguel', population: 133059 },
  { name: 'Independencia', slug: 'independencia', population: 142065 },
  { name: 'Recoleta', slug: 'recoleta', population: 190075 },
  { name: 'Conchalí', slug: 'conchali', population: 139195 },
  { name: 'Quilicura', slug: 'quilicura', population: 254694 },
  { name: 'Pudahuel', slug: 'pudahuel', population: 253139 },
  { name: 'Cerro Navia', slug: 'cerro-navia', population: 148312 },
  { name: 'Quinta Normal', slug: 'quinta-normal', population: 116349 },
  { name: 'Lo Prado', slug: 'lo-prado', population: 112565 },
  { name: 'Estación Central', slug: 'estacion-central', population: 206792 }
];

export const chileExpanded = {
  code: 'CL',
  name: 'Chile',
  slug: 'chile',
  population: 19116201,
  topCities: [
    { name: 'Santiago', slug: 'santiago', population: 6257516 },
    ...chileAdditionalCities
  ]
};
